import * as React from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import HelpOutlinedIcon from "@mui/icons-material/HelpOutlined";

const MoreInfoPopover = ({ nombre, info }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  // const [open, setOpen] = React.useState(false);

  const handlePopoverOpen = (event) => {
    // Establece el ancla al elemento que disparó el evento (el Box)
    setAnchorEl(event.currentTarget);
    // setOpen(true);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    // setOpen(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? `info-popover-${nombre}` : undefined;

  return (
    <div>
      {/* 1. Usamos Box con 'inline-flex' para que ocupe solo el espacio necesario.
        2. El Box contiene el ícono y el texto directamente.
        3. Todos los eventos de apertura/cierre están en el Box.
      */}
      <Box
        aria-describedby={id}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={(e) => {
          // Usa un pequeño delay para evitar el cierre instantáneo al pasar al popover
          setTimeout(() => {
            if (!document.getElementById(id)?.matches(":hover")) {
              handlePopoverClose();
            }
          }, 100);
        }}
        // onMouseLeave={handlePopoverClose} // Manejo del cierre
        // onTouchStart={handlePopoverOpen}
        // onClick={handlePopoverOpen}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer",
          color: "#eeececff",
          p: 0.5,
          borderRadius: 1,
          gap: 0.5, // Simula el Stack spacing
          "&:hover": {
            backgroundColor: "rgba(13, 175, 105, 0.1)",
          },
        }}
      >
        <HelpOutlinedIcon sx={{ fontSize: 20, color: "#fff" }} />
        <Typography component="span" variant="p" fontWeight="medium" sx={{ lineHeight: "normal" }}>
          Más Información
        </Typography>
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          onMouseEnter: handlePopoverOpen, // Mantiene abierto si entra al popover
          onMouseLeave: handlePopoverClose, // Cierra al salir del popover
          sx: { p: 2, maxWidth: 300 },
        }}
      >
        {info}
      </Popover>
    </div>
  );
};

export default MoreInfoPopover;
